import { FC, Dispatch, useEffect, useState } from "react";
import {
  StopEventPropagation,
  UpdateUserLastActionDate,
} from "../../../helper/ui/methods";
import { UserInterface } from "../../../middleware/interfaces/user/user-interface";

interface responseDialogProps {
  user?: UserInterface;
  title: string;
  message: string;
  progress?: number | null;
  archiveProgress?: number | null;
  dispatch: Dispatch<any>;
}

const ResponseDialog: FC<responseDialogProps> = ({
  user,
  title,
  message,
  progress,
  archiveProgress,
  dispatch,
}) => {
  const [ok, setOk] = useState(false);

  const HandleResponseDialogClick = (event: React.MouseEvent) => {
    // the click is contained whether or not anyone is signed in; only the
    // activity ping needs a user
    StopEventPropagation(event);
    if (user) {
      UpdateUserLastActionDate(user, dispatch);
    }
  };

  const HandleResponseDialogDoubleClick = (event: React.MouseEvent) => {
    StopEventPropagation(event);
  };

  useEffect(() => {
    if (ok) {
      setOk(false);
      dispatch({
        type: "RESPONSE",
        response: "",
      });
    }
  }, [ok]);

  return (
    <>
      {(() => {
        if (message !== "" && message !== undefined && message !== null) {
          // Busy states with no acknowledgement to make, so none gets an Ok
          // button. PREPARING covers the IFC to fragments conversion, which is
          // local CPU work with no bytes in flight and so nothing to measure;
          // ARCHIVING covers a folder or project being fetched and bundled in
          // the browser, where the manifest gives us real sizes to report.
          if (
            message === "WAIT" ||
            message === "PREPARING" ||
            message === "ARCHIVING"
          ) {
            return (
              <div
                className="dialogCover"
                onClick={HandleResponseDialogClick}
                onDoubleClick={HandleResponseDialogDoubleClick}
              >
                <div className="dialog">
                  <div className="dialogHeader">
                    <div className="dialogHeading">
                      <h2 className="dialogTitle">Working</h2>
                    </div>
                  </div>
                  <div className="dialogBody">
                    <h4 className="dialogMessage">
                    {message === "PREPARING"
                      ? "Preparing model..."
                      : message === "ARCHIVING"
                        ? archiveProgress !== null &&
                          archiveProgress !== undefined
                          ? `Preparing archive... ${archiveProgress}%`
                          : "Preparing archive..."
                        : progress !== null && progress !== undefined
                          ? `Uploading... ${progress}%`
                          : "Please wait"}
                    </h4>
                  </div>
                </div>
              </div>
            );
          } else {
            return (
              <div
                className="dialogCover"
                onClick={HandleResponseDialogClick}
                onDoubleClick={HandleResponseDialogDoubleClick}
              >
                <div className="dialog">
                  <div className="dialogHeader">
                    <div className="dialogHeading">
                      <h2 className="dialogTitle">{title}</h2>
                    </div>
                    <span
                      className="dialogClose"
                      onClick={() => {
                        setOk(true);
                      }}
                    >
                      ×
                    </span>
                  </div>
                  <div className="dialogBody">
                    <h4 className="dialogMessage">{message}</h4>
                  </div>
                  <div className="dialogButtonWrapper">
                    <input
                      className="dialogPrimaryButton"
                      type="button"
                      name="ok"
                      value="Ok"
                      onClick={() => {
                        setOk(true);
                      }}
                    />
                  </div>
                </div>
              </div>
            );
          }
        } else {
          return <></>;
        }
      })()}
    </>
  );
};

export default ResponseDialog;
